import cx from 'classnames';
import { CSSProperties, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getMockClientStatus } from 'utils/mock-client';
import { getMockClientRegistered } from 'utils/mock-client-variant';
import s from './demo-mode-mark.module.scss';

export const LoadingCertificates = ({ isLoading }: { isLoading: boolean }) => {
  if (!isLoading || !getMockClientRegistered()) {
    return null;
  }

  return (
    <div className={s.loading}>
      <div className={s.spinner} />
      <div className={s.loadingText}>
        Пожалуйста, подождите, пока система подготовит сертификаты для входа.
        Обычно эта операция занимает около 30 секунд
      </div>
    </div>
  );
};

export const DemoModeMark = ({ style, className }: { style?: CSSProperties; className?: string }) => {
  const { t } = useTranslation();
  const [isDemoMode, setIsDemoMode] = useState(false);

  useEffect(() => {
    setIsDemoMode(!!getMockClientStatus());
  }, []);

  if (!isDemoMode) {
    return null;
  }

  return (
    <div className={cx(s.mark, className)} style={style}>
      {t('Demo Mode Mark')}
    </div>
  );
};
